module.exports = "https://img.zhijierongxing.com/saas/img/guid_icon.79872798.png";